/**
 * IA Corner class representing AI-generated corner content.
 * Extends the base Event class to provide specific functionality for IA Corners,
 * including character images and backgrounds used for AI-generated content displays.
 */

import Content from '../types/enums/content';
import Event from './event';
import ImageUtils from '@shared/utils/image';
import { IIACornerEventRequest } from '../types/interfaces/event';

/**
 * IA Corner class for AI-generated corner content.
 * Handles character-specific image properties and extends base event functionality.
 */
class IACorner extends Event {
  characterImage: string;
  characterBackground: string;
  code: string;
  name: string;

  constructor(request: IIACornerEventRequest) {
    super({ ...request, type: Content.IA_CORNER });
    this.characterBackground = ImageUtils.getImage(
      request.moviePictures?.profileCharacterBackground || '',
      'poster'
    );
    this.characterImage = ImageUtils.getImage(
      request.moviePictures?.profileCharacterImage || '',
      'photo'
    );
    this.code = request.code;
    this.name = request.name;
  }
}

export default IACorner;
